import React from 'react';
import { View, Text } from 'react-native';
import { PnmacUIButton, PnmacImage } from 'pnmac-universal-components';
import styles from './HomeCard.styles';
import { useSelector } from 'react-redux';
import CaretRightSVG from '../assets/caret-right.svg';
var HomeCard = function (_a) {
  var nativeID = _a.nativeID,
    title = _a.title,
    icon = _a.icon,
    body = _a.body,
    buttonText = _a.buttonText,
    _b = _a.buttonDisabled,
    buttonDisabled = _b === void 0 ? false : _b,
    onButtonPress = _a.onButtonPress,
    small = _a.small;
  var mobile = useSelector(function (store) {
    return store.mobile;
  });
  // Render the body as a Text component if it's not a valid React element
  // This allows for passing in strings or other components
  var bodyComponent = /*#__PURE__*/React.isValidElement(body) ? body : (/*#__PURE__*/React.createElement(Text, {
    style: styles.bodyText
  }, body));
  return /*#__PURE__*/React.createElement(View, {
    nativeID: nativeID,
    style: [styles.cardContainer, {
      flexBasis: small ? '100%' : '30%'
    }]
  }, /*#__PURE__*/React.createElement(View, {
    nativeID: "".concat(nativeID, "-card"),
    style: styles.card
  }, /*#__PURE__*/React.createElement(View, {
    nativeID: "".concat(nativeID, "-header"),
    style: styles.header
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.titleText
  }, title), /*#__PURE__*/React.createElement(View, {
    style: styles.icon
  }, icon && icon())), /*#__PURE__*/React.createElement(View, {
    nativeID: "".concat(nativeID, "-body"),
    style: styles.body
  }, bodyComponent), /*#__PURE__*/React.createElement(View, {
    nativeID: "".concat(nativeID, "-footer"),
    style: styles.footer
  }, buttonText && (/*#__PURE__*/React.createElement(PnmacUIButton, {
    style: styles.button,
    hoverColor: '#cce9f5',
    disabled: buttonDisabled,
    uppercase: true,
    iconSize: 30,
    iconStyles: {
      marginLeft: 10
    },
    onPress: onButtonPress
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.buttonText
  }, buttonText), PnmacImage(mobile ? 'caretRight' : CaretRightSVG, 25, 'ApplyNow CaretRight icon', 'xml'))))));
};
export default HomeCard;